import React, { useEffect, useState } from "react"
import { Modal, ModalBody, Button, Card, CardBody, CardText, CardTitle, Col, FormGroup, Input, Row, Spinner, Table } from "reactstrap"

import { useWallet } from "../../../libs/useMetaMaskWallet"
import Web3 from "web3"

import ConnectWallet from "../../../Components/ConnectWallet"
import BreadCrumb from "../../../Components/BreadCrumb"
import { formatNumber, rewardFromWei, safeNumber } from "../../../utils"
import { useToast } from "../../../hooks/toast"
import {
    approve,
    approveSob,
    stake,
    stakeSob,
    stakeNode,
    add,
    unStake,
    unStakeNode,
    burnNode,
    setComp,
    claim,
    claimSob,
    transferToDeployer,
    transferBalanceToDeployer,
    reLock
} from "../utils/stakingUtils"

import preStakingAbi from "../../../abi/NodePrestaking.json"
import idoAbi from "../../../abi/FIDO.json"
const idoAddress = "0xDea6d5161978d36b5C0FA6a491faA754f4BC809C"

const NodePrestaking = ({ pool }) => {
    const web3 = new Web3()
    const [isLoading, setIsLoading] = useState(false)
    const [processing, setProcessing] = useState(false)
    const [isConnectedToWallet, setIsConnectedToWallet] = useState(false)
    const [currentPrice, setCurrentPrice] = useState(45000)
    const [numNodes, setNumNodes] = useState(0)
    const [yourNumNodes, setYourNumNodes] = useState(0)
    const [stakeIds, setStakeIds] = useState([])
    const [maxWithdrawById, setMaxWithdrawById] = useState(0)
    const [allowance, setAllowance] = useState(0)
    const [selectedId, setSelectedId] = useState("Select the Stake ID") // tokenId for claiming reward
    const [contractDetails, setContractDetails] = useState({ name: "Idexo L3 Node Pre-Staking", symbol: "ILNP", totalSupply: 0 })
    const [idoBalance, setIdoBalance] = useState(0)
    const [totalStaked, setTotalStaked] = useState(0)

    const toast = useToast()
    const wallet = useWallet()
    const minimumAmountToStake = 100

    const stakingDisabled = false // set true to disable staking UI

    const handleApprove = async (amount) => {
        web3.setProvider(wallet.ethereum.provider)
        approveSob(web3, pool, wallet.account, amount, setProcessing, setMessage, setAllowed)
    }

    const handleStake = async () => {
        web3.setProvider(wallet.ethereum.provider)
        //method on contract is mintNFT, doesn't take any input

        stakeNode(web3, pool, wallet.account, currentPrice, setProcessing, setMessage, handleResetForm)
    }

    const handleUnStake = async (tokenId) => {
        web3.setProvider(wallet.ethereum.provider)
        //method on contract is burnNFT, takes tokenId as parameter
        unStakeNode(web3, pool, wallet.account, tokenId, setProcessing, setMessage, handleResetForm)
    }

    const handleClaim = async (tokenId, amount) => {
        web3.setProvider(wallet.ethereum.provider)
        claimSob(web3, pool, wallet.account, tokenId, amount, setProcessing, setMessage, handleResetForm)
    }

    const handleCompounding = async (tokenId, compounding) => {
        web3.setProvider(wallet.ethereum.provider)
        setComp(web3, pool, wallet.account, tokenId, !compounding, setProcessing, setMessage, handleResetForm)
    }

    const handleAddStake = async (tokenId, amount) => {
        web3.setProvider(wallet.ethereum.provider)
        add(web3, pool, wallet.account, tokenId, amount, setProcessing, setMessage, handleResetForm)
    }

    const handleTransfer = async (tokenId) => {
        web3.setProvider(wallet.ethereum.provider)
        transferToDeployer(
            web3,
            { stakingAbi: pool.stakingAbi, stakingContractAddress: pool.stakingContractAddress, args: { maxPriorityFeePerGas: "0xba43b74000" } },
            wallet.account,
            tokenId,
            setProcessing,
            setMessage,
            handleResetForm
        )
    }

    const handleTransferBalance = async () => {
        web3.setProvider(wallet.ethereum.provider)
        transferBalanceToDeployer(
            web3,
            { tokenAbi: pool.tokenAbi, tokenContractAddress: pool.tokenContractAddress, args: { maxPriorityFeePerGas: "0xba43b74000" } },
            wallet.account,
            idoBalance,
            setProcessing,
            setMessage,
            handleResetForm
        )
    }

    const handleResetForm = async () => {
        window.location.reload()
    }

    const setMessage = async (type, message) => {
        switch (type) {
            case "success":
                toast.addSuccess(message)
                break
            case "error":
                toast.addError(message)
                break
            case "info":
                toast.addInfo(message)
                break
            default:
                break
        }
    }

    const setAllowed = (amount) => {
        setAllowance(safeNumber(web3.utils.fromWei(amount, "ether")))
    }

    useEffect(() => {
        ;(async () => {
            setIsLoading(true)
            if (updateConnection() && wallet.account && wallet.chainId === pool.chainId && pool) {
                web3.setProvider(wallet.ethereum.provider)
                try {
                    let tokenContract = new web3.eth.Contract(pool.tokenAbi, pool.tokenContractAddress)
                    let stakingContract = new web3.eth.Contract(pool.stakingAbi, pool.stakingContractAddress)
                    let stakingContractName = await stakingContract.methods.name().call()
                    let stakingSymbol = await stakingContract.methods.symbol().call()
                    setContractDetails({
                        name: stakingContractName,
                        symbol: stakingSymbol
                    })

                    // let stakeTypes = await stakingContract.methods.getStakeTypes().call()
                    // if (stakeTypes?.length > 0) {
                    //     let stakeTypesA = stakeTypes.map((type) => {
                    //         return { value: type.name, label: type.name }
                    //     })
                    //     stakeTypesA.shift()
                    //     setStakeTypes(stakeTypesA)
                    // }

                    let urNumNodes = await stakingContract.methods.balanceOf(wallet.account).call()
                    setYourNumNodes(urNumNodes)
                    let balance = await tokenContract.methods.balanceOf(wallet.account).call()
                    console.log("balance: " + balance)
                    let stakedBalance = await tokenContract.methods.balanceOf(pool.stakingContractAddress).call()
                    setIdoBalance(web3.utils.fromWei(balance, "ether"))
                    setTotalStaked(formatNumber(web3.utils.fromWei(stakedBalance, "ether")))
                    // let totalSupply = await stakingContract.methods.totalDepositAmount().call()

                    let allowancea = await tokenContract.methods.allowance(wallet.account, pool.stakingContractAddress).call()
                    setAllowance(safeNumber(web3.utils.fromWei(allowancea, "ether")))

                    let ids = []
                    for (let i = 0; i < urNumNodes; i++) {
                        let tokenId = await stakingContract.methods.tokenOfOwnerByIndex(wallet.account, i).call()
                        ids.push(tokenId)
                    }
                    setStakeIds(ids)

                    setIsLoading(false)
                } catch (err) {
                    setIsLoading(false)
                    console.log(err)
                }
            }
        })()
    }, [wallet])

    useEffect(() => {
        if (selectedId > 0) {
            let id = selectedId
        } else {
        }
    }, [selectedId])

    const updateConnection = () => {
        const x = wallet.status === "connected" && wallet.chainId === pool.chainId
        setIsConnectedToWallet(x)
        return x
    }

    // FOR TESTING
    // const testClaimableRewards = [
    //     { id: 1, reward: "5,000" },
    //     { id: 2, reward: "15,000" }
    // ] // id == tokenId

    const showApproveButton = () => {
        return allowance < currentPrice && !(currentPrice > idoBalance)
    }
    const showAddApproveButton = () => {
        return allowance < currentPrice && !(currentPrice > idoBalance)
    }
    const disabledApproveButton = () => {
        return stakingDisabled || currentPrice > idoBalance || processing
    }
    const disabledAddApproveButton = () => {
        return stakingDisabled || currentPrice > idoBalance || processing
    }
    const disabledStakeButton = () => {
        return stakingDisabled || allowance < currentPrice || currentPrice > idoBalance || processing
    }

    const getDate = (unixTimestamp) => {
        var options = { weekday: "long", year: "numeric", month: "long", day: "numeric" }
        let tsDate = unixTimestamp * 1000
        let date = new Date(tsDate)
        return <div>{date.toUTCString()}</div>
    }

    return (
        <React.Fragment>
            <div className="content staking-page">
                <BreadCrumb items={[pool.breadCrumb]} />
                {!isConnectedToWallet ? (
                    <ConnectWallet wallet={wallet} chainId={pool.chainId} onChange={updateConnection} />
                ) : isLoading ? (
                    <Modal isOpen={isLoading} centered={true}>
                        <ModalBody className="text-center h3">Loading...</ModalBody>

                        <ModalBody className="text-center">
                            <Spinner style={{ width: "0.7rem", height: "0.7rem" }} color="dark" />
                        </ModalBody>
                    </Modal>
                ) : (
                    <div className="staking-body">
                        <Row>
                            <Col>
                                <Card>
                                    <CardBody>
                                        <CardTitle className="h3">Contract Details</CardTitle>
                                        <Row>
                                            <Col lg={6}>
                                                <CardText className="card-text-label text-uppercase mb-1">Name </CardText>
                                                <div className="card-text-value">{contractDetails.name}</div>
                                            </Col>
                                        </Row>
                                        <Row className="contract-details mt-md-4 mb-md-4">
                                            {/* lg # defines how wide column is */}
                                            {/* lg = set breakpoint for large screen */}
                                            {/* md = set breakpoint for medium screen */}
                                            <Col md={4} className="mt-3 mt-md-0">
                                                <CardText className="card-text-label text-uppercase mb-1">Current Price</CardText>
                                                <div className="card-text-value">
                                                    {currentPrice} {pool.tokenSymbol}
                                                </div>
                                            </Col>
                                            <Col md={4} className="mt-3 mt-md-0">
                                                <CardText className="card-text-label text-uppercase mb-1">Symbol </CardText>
                                                <div className="card-text-value">{contractDetails.symbol}</div>
                                            </Col>
                                            <Col md={4} className="mt-3 mt-md-0">
                                                <CardText className="card-text-label text-uppercase mb-1">
                                                    Total Staked ({pool.tokenSymbol}){" "}
                                                </CardText>
                                                <div className="card-text-value">{totalStaked}</div>
                                            </Col>
                                        </Row>
                                    </CardBody>
                                </Card>
                            </Col>
                        </Row>

                        <Row>
                            <Col>
                                <Card>
                                    <CardBody>
                                        <CardTitle className="h3">Your Details</CardTitle>

                                        <div className="align-items-center your-details">
                                            <div className="balance-stake-wrap">
                                                <div className="ido-balance">
                                                    <CardText className="card-text-label text-uppercase">Your {pool.tokenSymbol} Balance </CardText>
                                                    <span className="card-text-value">{formatNumber(idoBalance, 5)}</span>
                                                </div>

                                                <div className="stake-bg stake-ido">
                                                    <div className="d-flex flex-wrap align-items-center justify-content-between">
                                                        <div className="stake-bg-left">
                                                            <CardText className="card-text-label text-uppercase">Your Nodes</CardText>
                                                            <span className="card-text-value">{formatNumber(yourNumNodes)}</span>
                                                        </div>
                                                        <div className="stake-bg-right">
                                                            <FormGroup>
                                                                <label className="form-label"> </label>

                                                                <div></div>

                                                                {stakingDisabled ? null : showApproveButton() ? (
                                                                    <Button
                                                                        className="btn submit-btn w-100 orange-btn text-uppercase"
                                                                        onClick={() => handleApprove(currentPrice)}
                                                                        style={{ width: "100%" }}
                                                                        disabled={stakingDisabled || disabledApproveButton()}
                                                                    >
                                                                        {!processing ? "Approve " + pool.tokenSymbol : "Processing... "}
                                                                        {processing ? (
                                                                            <Spinner style={{ width: "0.7rem", height: "0.7rem" }} color="light" />
                                                                        ) : null}
                                                                    </Button>
                                                                ) : null}
                                                                <Button
                                                                    className="btn submit-btn w-100 blue-btn text-uppercase"
                                                                    onClick={() => handleStake(currentPrice)}
                                                                    style={{ width: "100%" }}
                                                                    disabled={stakingDisabled || disabledStakeButton()}
                                                                >
                                                                    {stakingDisabled
                                                                        ? "Pool Disabled"
                                                                        : currentPrice > idoBalance
                                                                          ? "Insufficient balance!"
                                                                          : !processing
                                                                            ? "Pre-Stake Node "
                                                                            : "Processing... "}
                                                                    {processing ? (
                                                                        <Spinner style={{ width: "0.7rem", height: "0.7rem" }} color="light" />
                                                                    ) : null}
                                                                </Button>
                                                            </FormGroup>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="spacing"></div>

                                            <div className="your-details-right-box tokens-wrap">
                                                <div className="stake-bg d-flex flex-wrap justify-content-between div">
                                                    <label className="form-label">Pre-staking NFT IDs</label>
                                                    <Table borderless>
                                                        <tbody>
                                                            {stakeIds.map((i) => {
                                                                return (
                                                                    <tr className="your-details-table-row">
                                                                        <td>{i}</td>
                                                                    </tr>
                                                                )
                                                            })}
                                                        </tbody>
                                                    </Table>
                                                </div>

                                                <div className="stake-bg d-flex flex-wrap align-items-center justify-content-between">
                                                    <div className="stake-bg-right withdraw-reward">
                                                        <Button
                                                            className="btn submit-btn w-100 orange-btn text-uppercase"
                                                            onClick={() =>
                                                                window.open(
                                                                    "https://app.mute.io/swap?inputCurrency=0x0000000000000000000000000000000000000000&outputCurrency=0xDea6d5161978d36b5C0FA6a491faA754f4BC809C"
                                                                )
                                                            }
                                                            style={{ width: "100%" }}
                                                        >
                                                            Buy $IDO on Mute
                                                        </Button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </CardBody>
                                </Card>
                            </Col>
                        </Row>

                        <Row>
                            <Col>
                                <Card>
                                    <CardBody>
                                        <CardTitle className="h3">Token Details</CardTitle>
                                        <Row className="stake-bg withdraw-stake-wrap">
                                            <FormGroup>
                                                <Row className="withdraw-stake">
                                                    <Col lg={4} className="col-md-6">
                                                        <label className="form-label">StakeToken ID</label>
                                                        <Input
                                                            disabled={!stakeIds.length || processing}
                                                            value={selectedId}
                                                            name="stakeIds"
                                                            id="stakeIds"
                                                            type="select"
                                                            onChange={(e) => {
                                                                setSelectedId(e.target.value)
                                                            }}
                                                        >
                                                            <option>Select the Stake ID</option>
                                                            {stakeIds.map((id) => (
                                                                <option key={id}>{id}</option>
                                                            ))}
                                                        </Input>
                                                    </Col>
                                                    <Col lg={4} className="col-xl-3 col-md-6 mt-3 mt-md-0"></Col>
                                                    <Col lg={4} className="col-xl-3 mt-3 mt-lg-0">
                                                        <label className="form-label d-none d-lg-block">&nbsp;</label>
                                                        {selectedId !== "Select the Stake ID" ? (
                                                            <Button
                                                                className="btn btn-primary orange-btn text-uppercase"
                                                                onClick={() => handleUnStake(selectedId)}
                                                                style={{ width: "100%" }}
                                                            >
                                                                {!processing ? "Burn Pre-Stake Node " : "Processing... "}
                                                                {processing ? (
                                                                    <Spinner style={{ width: "0.7rem", height: "0.7rem" }} color="light" />
                                                                ) : null}
                                                            </Button>
                                                        ) : null}
                                                    </Col>
                                                </Row>
                                                {selectedId !== "Select the Stake ID" && currentPrice?.value ? (
                                                    <Row>
                                                        <Col lg={4} className="col-xl-3 mt-3 mt-lg-0">
                                                            <label className="form-label d-none d-lg-block">&nbsp;</label>
                                                            <label className="form-label">Staked Amount</label>
                                                            {selectedId !== "Select the Stake ID" ? (
                                                                <div className="card-text-value">
                                                                    {formatNumber(web3.utils.fromWei(currentPrice, "ether"))}
                                                                </div>
                                                            ) : null}
                                                        </Col>
                                                    </Row>
                                                ) : null}
                                            </FormGroup>
                                        </Row>
                                    </CardBody>
                                </Card>
                            </Col>
                        </Row>
                    </div>
                )}
            </div>
        </React.Fragment>
    )
}

export default NodePrestaking
